export const stepsData = [
  {
    id: "step-one",
    title: "01",
    description: "Consultation",
    content: {
      title: "Consultation",
      text: "Understand your business structure and objectives.",
    },
    imageSrc: require("../../../image/custom-software/step-one.webp"),
  },
  {
    id: "step-two",
    title: "02",
    description: "Design",
    content: {
      title: "Design",
      text: "Create a flexible and scalable ERP architecture.",
    },
    imageSrc: require("../../../image/custom-software/step-two.webp"),
  },
  {
    id: "step-three",
    title: "03",
    description: "Development",
    content: {
      title: "Development",
      text: "Build robust modules for seamless integration.",
    },
    imageSrc: require("../../../image/custom-software/step-three.webp"),
  },
  {
    id: "step-four",
    title: "04",
    description: "Implementation",
    content: {
      title: "Implementation",
      text: "Roll out the ERP system with minimal disruption.",
    },
    imageSrc: require("../../../image/custom-software/step-four.webp"),
  },
  {
    id: "step-five",
    title: "05",
    description: "Training and Support",
    content: {
      title: "Training and Support",
      text: "Provide user training and ongoing support for smooth operations.",
    },
    imageSrc: require("../../../image/custom-software/step-five.webp"),
  },
];
